<template lang="pug">
  div.metaList
    a.button.special.getItem(:href="this.product.directRef")
      .title {{!product.active ? 'Coming soon' : 'Take course'}}
    ol
      li(v-for="(n, i) in this.items") {{ n }}
</template>

<script>
// import pageBase from '@/scenes/_pageBase.js'

// TODO .getItem button should be inserted/nested from outside the component

export default {
  name: 'metaList',
  mixins: [],
  props: ['items', 'product'],
  components: {},
  data: function () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  },
  watch: {
  }
}

</script>

<style lang="scss" scoped>

.metaList{
  display: flex;
  position: relative;

  flex-direction: column;
  flex: 1;
  min-width: 200px;

  margin-right: $body-gutter;

  ol, ul{
    list-style: none;
    margin: 0;
    font-family: 'Mononoki', monospace;
    color: get-color(primary-min1);

    margin-top: 2rem;
    li{
      position: relative;
      text-align: center;
      margin-bottom: 4.2rem;

      &:first-child:before,
      &:first-child:after{
        display: none;
      }
      &:before,
      &:after{
        content: '';
        display: block;
        position: absolute;
      }
      &:before{
        width: 10px;
        height: 10px;
        top: -17px;
        border-radius: 3px;
        transform: rotate(45deg);
        border: 2px solid get-color(primary);
        left: calc(50% - 5px);
      }
      &:after{
        background: get-color(primary);
        width: 2px;
        height: 20px;
        top: -36px;
        left: calc(50% - 1px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/metaList.vue